import axios from "axios";

/**
 * Envoi des messages du formulaire de contact.
 *
 * REACT_APP_CONTACT_API_URL est l'URL complète du point d'entrée (POST, JSON, public) :
 *   { name, email, phone, topic, message, language, source }
 * Une réponse 2xx vaut accusé de réception. Tant qu'elle n'est pas renseignée, la page
 * propose de finaliser l'envoi depuis la boîte mail de l'utilisateur.
 */
const CONTACT_API_URL = (process.env.REACT_APP_CONTACT_API_URL || "").trim();

export const isContactApiConfigured = () => CONTACT_API_URL !== "";

export const sendContactMessage = (message) =>
    axios.post(CONTACT_API_URL, { ...message, source: "agro-landing-page/contact" }, { timeout: 15000 });
